import React, { useCallback } from 'react';
import {
    LoginBoxStyled,
    LoginStyled,
} from "../pages/Login/styled/LoginStyled";
import { useSetBodyBackgroundColor } from "../components/UseSetBodyBackgroundColor/useSetBodyBackgroundHooks";
import { useResponsive } from "../components/responsive";
import PageErrorContent, { IPageErrorContent } from "./PageErrorContent";
import { LoginWrapperHeaderStyled, LoginWrapperStyled } from "../modules/Login/components/styled/LoginWrapperStyled";
import appHistory from './appHistory';
import { RouterPaths } from './appConstants';
import LogoIcon from '../components/Logo/LogoIcon';

interface IPageError extends IPageErrorContent{
    headerPanelComponent?: JSX.Element;
}

const PageError = ({
   children,
   headerPanelComponent,
   ...pageErrorContentProps
}: IPageError) => {
    const {isSmallMaxWidth} = useResponsive();
    useSetBodyBackgroundColor('var(--app-bg-modal-color)', isSmallMaxWidth);

    const handleLogoClick = useCallback(() => {
        appHistory.push(RouterPaths.main);
    }, []);

    return <LoginWrapperStyled>
        <LoginWrapperHeaderStyled>
            <LogoIcon className={'logo'} onClick={handleLogoClick}/>
            {!!headerPanelComponent && headerPanelComponent}
        </LoginWrapperHeaderStyled>
        <LoginStyled>
            <LoginBoxStyled className="d-flex flex-column align-items-center">
                <PageErrorContent {...pageErrorContentProps}>
                    {children}
                </PageErrorContent>
            </LoginBoxStyled>
        </LoginStyled>
    </LoginWrapperStyled>
}

export default PageError;
